import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import Signup from "./pages/Signup/Signup";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import AppOutlet from "./components/AppOutlet";
import PageNotFound from "./pages/PageNotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import { useToken } from "./hooks/useAuth";
import Logout from "./pages/Logout";
import EmailVerification from "./pages/EmailVerification";
import IdentityVerification from "./pages/IdentityVerification";
import EmailInvitation from "./pages/EmailInvitation";
function App() {
  const { token } = useToken();
  return (
    <Routes>
      <Route path="email-invitation" element={<EmailInvitation />} />
      <Route path="logout" element={<Logout />} />
      <Route path="login" element={!token ? <Login /> : <Navigate to="/" />} />
      <Route
        path="forgot-password"
        element={!token ? <Login isForgot /> : <Navigate to="/" />}
      />
      <Route path="welcome" element={<EmailVerification />} />
      <Route path="identity-verification" element={<IdentityVerification />} />
      <Route
        path="profile-change-verification"
        element={<EmailVerification />}
      />
      {/* <Route path="providers/callback/login" element={<SSOCallbackLogin />} /> */}
      {/* <Route path="providers/callback/signup" element={<SSOCallbackSignup />} /> */}
      {/* <Route path="providers/callback/link-identity-provider" element={<SSOCallbackLinkIdentity />} /> */}
      <Route
        path="signup"
        element={!token ? <Signup /> : <Navigate to="/" />}
      />
      <Route
        path="reset-password"
        element={!token ? <ForgotPassword /> : <Navigate to="/" />}
      />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppOutlet />}>
          <Route path="/" element={<Home />} />
        </Route>
      </Route>

      <Route element={<AppOutlet />}>
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
